module.exports = __webpack_public_path__ + "img/background-2.a2b28675.jpg";